var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.editDevice)?_c('device-details',{attrs:{"device":_vm.device,"loading":_vm.loading},on:{"editCard":_vm.deviceEdit}}):_c('device-edit',{attrs:{"device":_vm.device},on:{"editCard":_vm.deviceEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }